(function () {
  'use strict';

  function qs(el, sel) {
    return el.querySelector(sel);
  }

  function qsa(el, sel) {
    return Array.prototype.slice.call(el.querySelectorAll(sel));
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function val(root, key) {
    var el = qs(root, '[data-lz-field="' + key + '"]');
    if (!el) return '';
    if (el.type === 'radio') {
      var checked = qs(root, '[data-lz-field="' + key + '"]:checked');
      return checked ? checked.value : '';
    }
    return el.value.trim();
  }

  function parseDob(value) {
    if (!value) return null;
    var parts = value.split('-');
    if (parts.length === 3) {
      var year = parseInt(parts[0], 10);
      var month = parseInt(parts[1], 10) - 1;
      var day = parseInt(parts[2], 10);
      if (year && !isNaN(month) && day) {
        return new Date(year, month, day);
      }
    }
    var parsed = new Date(value);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  function calcAge(dob) {
    var today = new Date();
    var age = today.getFullYear() - dob.getFullYear();
    var monthDiff = today.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  }

  function padLabel(label, width) {
    width = width || 18;
    return (label + ':').substring(0, width).padEnd(width, ' ');
  }

  function buildEmailBody(root, ctx) {
    var hasShopifyPhotos = ctx.hasShopifyPhotos;
    var photos = ctx.photos;

    var agencyLines = [];
    if (val(root, 'signed_agency') === 'Yes') {
      agencyLines.push('  ' + padLabel('Signed') + 'Yes');
      agencyLines.push('  ' + padLabel('Agency') + (val(root, 'agency_name') || '—'));
      agencyLines.push('  ' + padLabel('Restrictions') + val(root, 'agency_has_restrictions'));
      if (val(root, 'agency_restrictions')) {
        agencyLines.push('  ' + padLabel('Details') + val(root, 'agency_restrictions'));
      }
    } else {
      agencyLines.push('  Not signed by an agency');
    }

    var photoLines = [];
    if (hasShopifyPhotos) {
      photoLines.push('  ' + padLabel('Headshot') + 'Uploaded via Shopify Forms');
      photoLines.push('  ' + padLabel('Full body') + 'Uploaded via Shopify Forms');
      photoLines.push('  ' + padLabel('Match by email') + val(root, 'email'));
      photoLines.push('');
      photoLines.push('  → Photo files arrive in a separate Forms notification email.');
    } else {
      photoLines.push('  ' + padLabel('Headshot') + (photos.headshot.url.value || photos.headshot.filename.value || 'Not provided'));
      photoLines.push('  ' + padLabel('Full body') + (photos.fullbody.url.value || photos.fullbody.filename.value || 'Not provided'));
    }

    return [
      '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',
      '  LIZZARD MODEL RECRUITMENT — APPLICATION 2026',
      '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',
      '',
      'PERSONAL DETAILS',
      '────────────────────────────────────────',
      '  ' + padLabel('Name') + val(root, 'name'),
      '  ' + padLabel('Guardian') + (val(root, 'guardian_name') || 'N/A (18+)'),
      '  ' + padLabel('Date of birth') + val(root, 'date_of_birth'),
      '  ' + padLabel('Age') + val(root, 'age'),
      '  ' + padLabel('Phone') + val(root, 'phone'),
      '  ' + padLabel('Email') + val(root, 'email'),
      '',
      'CATEGORY',
      '────────────────────────────────────────',
      '  ' + val(root, 'model_category'),
      '',
      'SIZING',
      '────────────────────────────────────────',
      '  ' + padLabel('Body length') + val(root, 'body_length_cm') + ' cm',
      '  ' + padLabel('T-shirt') + (val(root, 'size_tshirt') || '—'),
      '  ' + padLabel('Pants') + (val(root, 'size_pants') || '—'),
      '  ' + padLabel('Jacket') + (val(root, 'size_jacket') || '—'),
      '  ' + padLabel('Dress') + (val(root, 'size_dress') || '—'),
      '  ' + padLabel('Bikini top') + (val(root, 'size_bikini_top') || '—'),
      '  ' + padLabel('Bikini bottom') + (val(root, 'size_bikini_bottom') || '—'),
      '',
      'AGENCY',
      '────────────────────────────────────────',
    ].concat(agencyLines).concat([
      '',
      'PHOTOS',
      '────────────────────────────────────────',
    ]).concat(photoLines).concat([
      '',
      'CONSENT CONFIRMED',
      '────────────────────────────────────────',
      '  ✓ Available Mon–Fri for photoshoots',
      '  ✓ All information is accurate',
      '  ✓ Contact may be shared with photoshoot parties',
      '  ✓ Images may be used for promotion if selected',
      '',
      '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',
      'Submitted via lizzardonline.com/pages/model-recruitment',
    ]).join('\n');
  }

  function init(root) {
    if (!root || root.dataset.lzModelInit) return;
    root.dataset.lzModelInit = '1';
    if (/iPhone|iPod/i.test(navigator.userAgent || '')) {
      root.classList.add('is-iphone');
    }

    var panels = qsa(root, '[data-lz-panel]');
    var steps = qsa(root, '[data-lz-progress] li');
    var reviewBox = qs(root, '[data-lz-review]');
    var bodyHidden = qs(root, '[data-lz-body]');
    var form = qs(root, '#LzModelApplication') || qs(root, 'form.contact-form') || qs(root, 'form');
    var formShell = qs(root, '[data-lz-form-shell]');
    var successPanel = qs(root, '[data-lz-success]');
    var submitError = qs(root, '[data-lz-submit-error]');
    var submitBtn = qs(root, '[data-lz-submit]');
    var uploadcareKey = root.dataset.uploadcareKey || '';
    var hasShopifyPhotos = root.dataset.lzHasShopifyPhotos === '1';
    var shopifyPhotosConfirm = qs(root, '[data-lz-shopify-photos-confirm]');
    var shopifyPhotosError = qs(root, '[data-lz-shopify-photos-error]');
    var photoStep = qs(root, '[data-lz-photo-step]');
    var categoryError = qs(root, '[data-lz-category-error]');
    var current = 0;
    var isSubmitting = false;

    var dobInput = qs(root, '[data-lz-dob]');
    var ageInput = qs(root, '[data-lz-age]');
    var agencyFields = qs(root, '[data-lz-agency-fields]');
    var restrictionsField = qs(root, '[data-lz-restrictions-field]');

    var photos = {
      headshot: {
        drop: qs(root, '[data-lz-photo-drop="headshot"]'),
        filename: qs(root, '[data-lz-headshot-filename]'),
        url: qs(root, '[data-lz-headshot-url]'),
        error: qs(root, '[data-lz-headshot-error]'),
        label: 'Headshot'
      },
      fullbody: {
        drop: qs(root, '[data-lz-photo-drop="fullbody"]'),
        filename: qs(root, '[data-lz-fullbody-filename]'),
        url: qs(root, '[data-lz-fullbody-url]'),
        error: qs(root, '[data-lz-fullbody-error]'),
        label: 'Full body shot'
      }
    };

    function setError(el, msg) {
      if (!el) return;
      el.hidden = !msg;
      el.textContent = msg || '';
    }

    function updateAge() {
      if (!dobInput || !ageInput) return;
      var dob = parseDob(dobInput.value);
      if (!dob) {
        ageInput.value = '';
        return;
      }
      var age = calcAge(dob);
      ageInput.value = age >= 0 ? String(age) : '';
    }

    function showSubmitError(msg) {
      if (!submitError) return;
      submitError.hidden = !msg;
      submitError.textContent = msg || '';
    }

    function showSuccessState() {
      if (formShell) formShell.classList.add('is-hidden');
      if (successPanel) successPanel.hidden = false;
      showSubmitError('');
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function setSubmitting(active) {
      isSubmitting = active;
      if (!submitBtn) return;
      submitBtn.disabled = active;
      submitBtn.classList.toggle('is-loading', active);
      submitBtn.textContent = active ? 'Submitting…' : 'Submit application';
    }

    function submitViaAjax() {
      if (!form || isSubmitting) return;
      setSubmitting(true);
      showSubmitError('');

      fetch('/contact', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      })
        .then(function (response) {
          return response.text().then(function (html) {
            return { ok: response.ok, html: html, url: response.url };
          });
        })
        .then(function (result) {
          var doc = new DOMParser().parseFromString(result.html, 'text/html');
          var errors = doc.querySelector('.lz-model-errors, .errors, .form-errors');
          var hasFieldErrors = errors && errors.textContent.trim().length > 0;
          var posted =
            result.html.indexOf('lzShowSuccess') !== -1 ||
            result.html.indexOf('posted_successfully') !== -1 ||
            /form-posted-success|thank you for contacting us/i.test(result.html);

          if (hasFieldErrors) {
            showSubmitError(errors.textContent.trim() || 'Please check your application and try again.');
            return;
          }

          if (result.ok && posted) {
            showSuccessState();
            return;
          }

          if (result.ok && !hasFieldErrors) {
            showSuccessState();
            return;
          }

          showSubmitError('Something went wrong. Please try again.');
        })
        .catch(function () {
          showSubmitError('Could not submit your application. Please check your connection and try again.');
        })
        .finally(function () {
          setSubmitting(false);
        });
    }

    function toggleAgencyFields() {
      var signed = val(root, 'signed_agency') === 'Yes';
      if (agencyFields) agencyFields.hidden = !signed;
    }

    function toggleRestrictionsField() {
      var hasRestrictions = val(root, 'agency_has_restrictions') === 'Yes';
      if (restrictionsField) restrictionsField.hidden = !hasRestrictions;
    }

    function validatePanel(index) {
      var panel = panels[index];
      if (!panel) return true;

      if (index === 0) {
        updateAge();
        if (dobInput && dobInput.value && ageInput && !ageInput.value.trim()) {
          dobInput.setCustomValidity('Please enter a valid date of birth.');
          dobInput.focus();
          dobInput.reportValidity();
          return false;
        }
        if (dobInput) dobInput.setCustomValidity('');
      }

      if (index === 1) {
        var categoryChecked = qs(panel, '[data-lz-field="model_category"]:checked');
        if (!categoryChecked) {
          setError(categoryError, 'Please select a category to continue.');
          return false;
        }
        setError(categoryError, '');
      }

      var required = qsa(panel, 'input[required], textarea[required], select[required]');
      for (var i = 0; i < required.length; i++) {
        var field = required[i];
        if (field.type === 'radio') {
          var fieldKey = field.getAttribute('data-lz-field');
          var group = fieldKey
            ? qsa(panel, '[data-lz-field="' + fieldKey + '"]')
            : qsa(panel, 'input[name="' + field.name + '"]');
          var anyChecked = group.some(function (r) { return r.checked; });
          if (!anyChecked) {
            field.focus();
            return false;
          }
        } else if (!field.value.trim()) {
          field.focus();
          field.reportValidity();
          return false;
        }
      }

      if (index === 4) {
        if (hasShopifyPhotos) {
          if (!shopifyPhotosConfirm || !shopifyPhotosConfirm.checked) {
            setError(shopifyPhotosError, 'Please upload your photos and confirm before continuing.');
            return false;
          }
          setError(shopifyPhotosError, '');
          return true;
        }

        if (!uploadcareKey) {
          setError(photos.headshot.error, 'Photo upload is not configured on this page yet.');
          return false;
        }

        if (!photos.headshot.url.value) {
          setError(photos.headshot.error, 'Please upload a headshot (JPEG). Wait for the upload to finish.');
          return false;
        }
        if (!photos.fullbody.url.value) {
          setError(photos.fullbody.error, 'Please upload a full body shot (JPEG). Wait for the upload to finish.');
          return false;
        }
        setError(photos.headshot.error, '');
        setError(photos.fullbody.error, '');
      }

      return true;
    }

    function findEmailInputs(scope) {
      var found = [];
      if (!scope) return found;
      var nodes = scope.querySelectorAll('input[type="email"], input[autocomplete="email"]');
      for (var i = 0; i < nodes.length; i++) found.push(nodes[i]);
      var all = scope.querySelectorAll('*');
      for (var j = 0; j < all.length; j++) {
        if (all[j].shadowRoot) {
          found = found.concat(findEmailInputs(all[j].shadowRoot));
        }
      }
      return found;
    }

    function prefillShopifyEmail() {
      var email = val(root, 'email');
      if (!email || !photoStep) return;
      var inputs = findEmailInputs(photoStep);
      inputs.forEach(function (el) {
        el.value = email;
        el.removeAttribute('disabled');
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
        el.dispatchEvent(new Event('blur', { bubbles: true }));
      });
    }

    function setPhotoStepVisible(show) {
      if (!photoStep) return;
      photoStep.classList.toggle('is-parked', !show);
      photoStep.removeAttribute('hidden');
      if (show) {
        prefillShopifyEmail();
        window.setTimeout(prefillShopifyEmail, 250);
        window.setTimeout(prefillShopifyEmail, 800);
        window.setTimeout(prefillShopifyEmail, 1600);
      }
    }

    function showPanel(index) {
      current = Math.max(0, Math.min(index, panels.length - 1));
      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === current);
      });
      steps.forEach(function (step, i) {
        step.classList.toggle('is-active', i === current);
        step.classList.toggle('is-done', i < current);
      });
      setPhotoStepVisible(hasShopifyPhotos && current === 4);
      if (current === panels.length - 1) {
        bindCaptcha();
        buildReview();
      }
    }

    function buildReview() {
      if (!reviewBox) return;

      var headshotLink = hasShopifyPhotos
        ? 'Uploaded via Shopify Forms (see separate notification email)'
        : (photos.headshot.url && photos.headshot.url.value)
          ? '<a href="' + esc(photos.headshot.url.value) + '" target="_blank" rel="noopener">View headshot</a>'
          : esc((photos.headshot.filename && photos.headshot.filename.value) || 'Not uploaded');
      var fullbodyLink = hasShopifyPhotos
        ? 'Uploaded via Shopify Forms (see separate notification email)'
        : (photos.fullbody.url && photos.fullbody.url.value)
          ? '<a href="' + esc(photos.fullbody.url.value) + '" target="_blank" rel="noopener">View full body shot</a>'
          : esc((photos.fullbody.filename && photos.fullbody.filename.value) || 'Not uploaded');

      var agencyBlock = val(root, 'signed_agency') === 'Yes'
        ? 'Agency: ' + esc(val(root, 'agency_name') || '—') +
          ' | Restrictions: ' + esc(val(root, 'agency_has_restrictions') || 'No') +
          (val(root, 'agency_restrictions') ? ' — ' + esc(val(root, 'agency_restrictions')) : '')
        : 'Not signed by an agency';

      reviewBox.innerHTML =
        '<dl class="lz-model-review">' +
        '<dt>Model</dt><dd>' + esc(val(root, 'name')) + '</dd>' +
        '<dt>Guardian</dt><dd>' + esc(val(root, 'guardian_name') || '—') + '</dd>' +
        '<dt>Date of birth / Age</dt><dd>' + esc(val(root, 'date_of_birth')) + ' / ' + esc(val(root, 'age')) + '</dd>' +
        '<dt>Contact</dt><dd>' + esc(val(root, 'phone')) + ' · ' + esc(val(root, 'email')) + '</dd>' +
        '<dt>Category</dt><dd>' + esc(val(root, 'model_category')) + '</dd>' +
        '<dt>Body length</dt><dd>' + esc(val(root, 'body_length_cm')) + ' cm</dd>' +
        '<dt>Clothing sizes</dt><dd>' +
          'T-shirt: ' + esc(val(root, 'size_tshirt') || '—') + '; ' +
          'Pants: ' + esc(val(root, 'size_pants') || '—') + '; ' +
          'Jacket: ' + esc(val(root, 'size_jacket') || '—') + '; ' +
          'Dress: ' + esc(val(root, 'size_dress') || '—') + '; ' +
          'Bikini top: ' + esc(val(root, 'size_bikini_top') || '—') + '; ' +
          'Bikini bottom: ' + esc(val(root, 'size_bikini_bottom') || '—') +
        '</dd>' +
        '<dt>Agency</dt><dd>' + agencyBlock + '</dd>' +
        '<dt>Headshot</dt><dd>' + headshotLink + '</dd>' +
        '<dt>Full body shot</dt><dd>' + fullbodyLink + '</dd>' +
        '</dl>';

      if (bodyHidden) {
        bodyHidden.value = buildEmailBody(root, {
          hasShopifyPhotos: hasShopifyPhotos,
          photos: photos
        });
      }
    }

    function initPhotoSlot(key) {
      var slot = photos[key];
      if (!slot.drop) return;

      var fileInput = qs(slot.drop, '[data-lz-photo-file]');
      var idle = qs(slot.drop, '[data-lz-drop-idle]');
      var preview = qs(slot.drop, '[data-lz-drop-preview]');
      var media = qs(slot.drop, '[data-lz-drop-media]');
      var filenameEl = qs(slot.drop, '[data-lz-drop-filename]');
      var clearBtn = qs(slot.drop, '[data-lz-photo-clear]');

      function clearPhoto() {
        if (fileInput) fileInput.value = '';
        if (slot.filename) slot.filename.value = '';
        if (slot.url) slot.url.value = '';
        if (media) media.innerHTML = '';
        if (idle) idle.hidden = false;
        if (preview) preview.hidden = true;
        slot.drop.classList.remove('has-file', 'is-drag');
        setError(slot.error, '');
      }

      function showPreview(file, dataUrl) {
        if (idle) idle.hidden = true;
        if (preview) preview.hidden = false;
        slot.drop.classList.add('has-file');
        if (filenameEl) filenameEl.textContent = file.name;
        if (media) {
          media.innerHTML = '';
          if (dataUrl) {
            var img = document.createElement('img');
            img.src = dataUrl;
            img.alt = slot.label;
            media.appendChild(img);
          }
        }
      }

      function acceptFile(file) {
        if (!file) return;
        setError(slot.error, '');

        if (!/\.jpe?g$/i.test(file.name) && file.type !== 'image/jpeg') {
          setError(slot.error, 'Please upload a JPEG image.');
          return;
        }
        if (file.size > 12 * 1024 * 1024) {
          setError(slot.error, 'File is too large (max 12MB).');
          return;
        }

        if (slot.filename) slot.filename.value = file.name;

        if (uploadcareKey && window.uploadcare && typeof window.uploadcare.fileFrom === 'function') {
          showPreview(file, URL.createObjectURL(file));
          window.uploadcare.fileFrom('object', file, { publicKey: uploadcareKey })
            .done(function (info) {
              if (slot.url) slot.url.value = info.cdnUrl;
              setError(slot.error, '');
            })
            .fail(function () {
              setError(slot.error, 'Upload failed. Please try again.');
              clearPhoto();
            });
          return;
        }

        showPreview(file, URL.createObjectURL(file));
        if (slot.url) slot.url.value = '';
      }

      if (fileInput) {
        fileInput.addEventListener('change', function () {
          if (fileInput.files && fileInput.files[0]) acceptFile(fileInput.files[0]);
        });
      }

      if (clearBtn) clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearPhoto();
      });

      slot.drop.addEventListener('dragover', function (e) {
        e.preventDefault();
        slot.drop.classList.add('is-drag');
      });
      slot.drop.addEventListener('dragleave', function () {
        slot.drop.classList.remove('is-drag');
      });
      slot.drop.addEventListener('drop', function (e) {
        e.preventDefault();
        slot.drop.classList.remove('is-drag');
        var files = e.dataTransfer && e.dataTransfer.files;
        if (files && files[0]) acceptFile(files[0]);
      });
    }

    qsa(root, '[data-lz-field="model_category"]').forEach(function (input) {
      input.addEventListener('change', function () {
        setError(categoryError, '');
      });
      input.addEventListener('click', function () {
        input.checked = true;
        setError(categoryError, '');
      });
    });

    qsa(root, '[data-lz-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (current === 0) updateAge();
        if (validatePanel(current)) showPanel(current + 1);
      });
    });

    qsa(root, '[data-lz-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showPanel(current - 1);
      });
    });

    qsa(root, '[data-lz-agency-toggle]').forEach(function (input) {
      input.addEventListener('change', toggleAgencyFields);
    });

    qsa(root, '[data-lz-restrictions-toggle]').forEach(function (input) {
      input.addEventListener('change', toggleRestrictionsField);
    });

    if (dobInput) dobInput.addEventListener('change', updateAge);
    if (dobInput) dobInput.addEventListener('input', updateAge);
    if (dobInput) dobInput.addEventListener('blur', updateAge);

    function bindCaptcha() {
      if (!form || form.dataset.lzCaptchaBound === '1') return;
      if (window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === 'function') {
        Shopify.captcha.protect(form);
        form.dataset.lzCaptchaBound = '1';
      }
    }

    if (form) {
      form.setAttribute('novalidate', 'novalidate');
      form.noValidate = true;
      bindCaptcha();
      form.addEventListener('focusin', bindCaptcha);
      form.addEventListener('submit', function (e) {
        bindCaptcha();
        if (!attemptSubmit()) {
          e.preventDefault();
          if (submitBtn) submitBtn.textContent = 'Submit application';
          return;
        }
      });
    }

    function attemptSubmit() {
      for (var i = 0; i < panels.length - 1; i++) {
        if (!validatePanel(i)) {
          showPanel(i);
          return false;
        }
      }

      var consents = qsa(root, '[data-lz-consent]');
      for (var j = 0; j < consents.length; j++) {
        if (!consents[j].checked) {
          showPanel(panels.length - 1);
          consents[j].focus();
          return false;
        }
      }

      buildReview();
      return true;
    }

    if (/[?&]application=submitted(?:=|&|$)/.test(window.location.search)) {
      showSuccessState();
      if (window.history.replaceState) {
        window.history.replaceState({}, '', window.location.pathname);
      }
    } else if (root.dataset.lzShowSuccess === '1') {
      showSuccessState();
    }

    initPhotoSlot('headshot');
    initPhotoSlot('fullbody');
    toggleAgencyFields();
    toggleRestrictionsField();
    updateAge();
  }

  function boot() {
    qsa(document, '[data-lz-model]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
